import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

interface FinalCTASectionProps {
  onGetStarted: () => void;
}

const FinalCTASection: React.FC<FinalCTASectionProps> = ({ onGetStarted }) => {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-primary-700 to-secondary relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6">
          {t('landing.finalCta.title')}
        </h2>
        <p className="text-lg text-white/80 mb-10 max-w-xl mx-auto">
          {t('landing.finalCta.subtitle')}
        </p>
        <button
          onClick={onGetStarted}
          className="inline-flex items-center gap-2 px-10 py-4 bg-white text-primary rounded-2xl font-bold text-lg hover:bg-gray-50 transition shadow-xl hover:-translate-y-0.5"
        >
          {t('common.getStartedFree')}
          <ArrowRight size={20} />
        </button>
      </div>
    </section>
  );
};

export default FinalCTASection;
